module.exports = __webpack_public_path__ + "static/scale-model-of-buckhead-goats™-farmhouse-in-sandy-springs-georgia-a8039b73d5d95500232aabd85ea07940.png";